<div class="modal fade" bsModal #addListModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Add Message Template</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="addListModal.hide()"></button>
      </div>
      <div class="modal-body">
        <div class="row" *ngIf="newMessageTemplate">
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Template Name</label>
              <div class="input-group m-b">
                  <input type="text" [(ngModel)]="newMessageTemplate.templateName" class="form-control"/>
              </div>
            </div>
          </div>          
        </div>
      </div>
      <div class="modal-footer">
        <button (click)="addListModal.hide()" class="btn btn-white">Cancel</button>
        <button (click)="addListSave();addListModal.hide()" class="btn btn-white">Save</button>
      </div>
    </div>
  </div>
</div>

<!--<div class="modal fade" bsModal #editListModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <b>Edit Message Template</b>
        <button type="button" class="close pull-right btn btn-outline-default" aria-label="Close" (click)="editListModal.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row" *ngIf="messageTemplate">
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Template Name</label>
              <div class="input-group m-b">
                  <input type="text" [(ngModel)]="messageTemplate.templateName" class="form-control"/>
              </div>
            </div>
          </div>
          
        </div>
      </div>
      <div class="modal-footer">
        <button (click)="editListModal.hide()" class="btn btn-white">Close</button>
        <button (click)="updateListSave();editListModal.hide()" class="btn btn-white">Save</button>
      </div>
    </div>
  </div>
</div>-->


<div class="modal fade modal-lg" bsModal #editTemplateModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Edit Message Template</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="editTemplateModal.hide()"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-6">
            <div class="form-group input-group-sm">
              <label>Template Name</label>
              <div class="input-group m-b" *ngIf="messageTemplate">
                  <input type="text" [(ngModel)]="messageTemplate.templateName" class="form-control" />
              </div>
            </div>
            <div class="form-group input-group-sm mt-3">
              <div class="form-check form-switch" *ngIf="messageTemplate">
                <input type="checkbox" class="form-check-input" id="useTemplate" [(ngModel)]="messageTemplate.advancedTemplates">
                <label class="form-check-label" for="useTemplate">Use Advanced Templates</label>
              </div>
            </div>
            <div class="form-group input-group-sm mt-3 alert alert-primary" *ngIf="messageTemplate && !messageTemplate.advancedTemplates">
              <label>Simple Message Template</label>
              <div><small>Expecting Text Alarm: use <code ng-non-bindable>{{textData}}</code> to display the text.</small></div>
              <div><small>Expecting JSON Alarm: use <code ng-non-bindable>{{jsonData}}</code> to display the a value in the JSON.</small></div>
            </div>
            <div class="form-group input-group-sm mt-3 alert alert-primary" *ngIf="messageTemplate && messageTemplate.advancedTemplates">
              <label>Advanced Message Template</label>
              <div>
                You can dynamically change the contents of the widget based on the latest value supplied.
                The widget uses <a href="https://handlebarsjs.com/" target="_blank">Handlebars</a> formatting so you can loop through data.
              </div>
              <div *ngIf="showExample">
                <b (click)="showExample = !showExample">Hide Example:</b>
                <br/>
<pre>
<code>
{{emailExample}}
</code>
</pre>
              </div>
              <div *ngIf="!showExample">
                <b (click)="showExample = !showExample">Show Example:</b>
              </div>
            </div>
            <div class="form-group input-group-sm">
              <label>Subject Template</label>
              <div class="input-group m-b" *ngIf="messageTemplate">
                  <input type="text" [(ngModel)]="messageTemplate.subjectTemplate" class="form-control" />
              </div>
            </div>
            <div class="form-group input-group-sm">
              <label>SMS Template</label>
              <div class="input-group m-b" *ngIf="messageTemplate">
                  <input type="text" [(ngModel)]="messageTemplate.smsTemplate" class="form-control" />
              </div>
            </div>            
            <div>
              <h3 class="h4">Body Template</h3>
              <div class="m-b" *ngIf="messageTemplate">
                <ngx-monaco-editor
                  [(ngModel)]="messageTemplate.bodyTemplate"
                  [options]="{ language: 'html', theme: 'vs-dark', readOnly: false, automaticLayout: true, scrollBeyondLastLine: false, minimap: { enabled: false } }"
                  class="template-editor"
                  style="height:250px;"
                  (ngModelChange)="messageChanged($event)"></ngx-monaco-editor>
              </div>
            </div>
            <div *ngIf="messageTemplate" class="mt-3">
              <h3 class="h4">Sample Value for Live Render</h3>
              <small>Use HTML syntax if you want to send HTML formatted emails.</small>
              <small>Should be either valid JSON, a string or a number</small>
              <ngx-monaco-editor
                [(ngModel)]="messageTemplate.sampleMessage"
                [options]="{ language: 'html', theme: 'vs-dark', readOnly: false, automaticLayout: true, scrollBeyondLastLine: false, minimap: { enabled: false } }"
                class="template-editor"
                style="height:250px;"
                (ngModelChange)="messageChanged($event)"></ngx-monaco-editor>
              <hr class="opacity-3 my-2 mx-n3">
            </div>
          </div>
          <div class="col-lg-6">
            
            <div class="card">
              <div class="card-header">
                  Live Render
              </div>
              <div class="card-body live-render">                     
                <span *ngIf="messageTemplate" [innerHTML]="liveRender"></span>
              </div>
              <div class="card-arrow">
                <div class="card-arrow-top-left"></div>
                <div class="card-arrow-top-right"></div>
                <div class="card-arrow-bottom-left"></div>
                <div class="card-arrow-bottom-right"></div>
              </div> 
            </div>                   
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button (click)="editTemplateModal.hide()" class="btn btn-white">Close</button>
        <button (click)="saveMessageTemplate(this.messageTemplate);editTemplateModal.hide()" class="btn btn-white">Save</button>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-lg-12">
    <div class="card mt-2 bg-emphasis bg-opacity-25">
      <div class="card-body">
        <div class="d-flex fw-bold small mb-3">
          <span class="flex-grow-1">
            <button (click)="addList();addListModal.show()" class="btn btn-outline-default">Add New Message Template</button>
          </span>
        </div>
        <table class="table table-striped"> 
          <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">Template Name</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngIf="service.loading">
              <td colspan="6"><div class="spinner-border"></div></td>
            </tr>
            <tr *ngFor="let list of remoteData | async">
              <td>{{list.messageTemplateId}}</td>
              <td>{{list.templateName}}</td>
              <td>
                <!-- edit template -->
                <a class="btn btn-outline-default" (click)="messageTemplate=list;editTemplateModal.show();messageChanged(null);"><i class="fa fa-code"></i></a>
                <!-- delete -->
                <a class="btn btn-outline-danger ml-2" (click)="removeRow(list)"><i class="fa fa-trash"></i></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-arrow">
        <div class="card-arrow-top-left"></div>
        <div class="card-arrow-top-right"></div>
        <div class="card-arrow-bottom-left"></div>
        <div class="card-arrow-bottom-right"></div>
      </div>
    </div>
  </div>  
</div>